<template>
  <div class="bd-t bd-l bd-b bd-r h-100">
    <el-form
      label-width="100px"
      ref="form"
      hide-required-asterisk
      :show-message="false"
      @validate="onFormValidate"
      :model="form"
      class="h-100"
    >
      <el-row>
        <el-col :span="24">
          <!--统计-->
          <div class="uk-flex uk-flex-middle bd-b pd-10">
            <el-col :span="18" class="uk-flex-inline uk-flex-middle">
              <el-form-item
                :label="$t('integration.statistics')"
                prop="name"
                :rules="[RuleRequiredFunc($t('public.please_select_statistics'), 'change')]"
              >
                <el-autocomplete
                  v-model="form.name"
                  style="width: 193px"
                  :placeholder="$t('placeholderText.EnterContent')"
                  :fetch-suggestions="queryStaticList"
                  @select="onStaticSelect"
                  suffix-icon="el-icon-arrow-down"
                  :maxlength="10"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="uk-flex uk-flex-middle">
              <el-button type="primary" @click="exp"
                >{{ $t('integration.export') }}
              </el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
      <el-row style="height:calc(100% - 70px);overflow-y: auto">
        <el-col :span="24" style="height: auto !important;">
          <div class="pd-10">
            <el-form-item
              :label="$t('integration.start_time')"
              prop="startTime"
              :rules="[RuleRequiredFunc($t('langText.StartTime_chooze'))]"
            >
              <el-date-picker
                type="datetime"
                v-model="form.startTime"
                style="width: 193px"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="24" style="height: auto !important;">
          <div class="pd-10">
            <el-form-item
              :label="$t('integration.end_time')"
              prop="endTime"
              :rules="[RuleRequiredFunc($t('langText.EndTime_chooze'))]"
            >
              <el-date-picker
                style="width: 193px"
                type="datetime"
                v-model="form.endTime"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24" style="height: auto !important;">
          <div class="pd-10">
            <el-form-item :label="$t('integration.range')">
              <!--  使用自定义区间 / 使用默认区间-->
              <el-row class="uk-margin-small-bottom">
                <!-- 检测区间第一行-->
                <el-col :span="24">
                  <el-select
                    v-model="form.monitorRange.sign"
                    @change="onMonitorSelect"
                  >
                    <el-option
                      :value="1"
                      :label="$t('public.use_custom_interval')"
                    ></el-option>
                    <el-option
                      :value="0"
                      :label="$t('public.use_default_interval')"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>

              <el-form-item
                v-for="(item, index) in form.monitorRange.rangeList"
                :key="index"
                :prop="`monitorRange.rangeList[${index}]`"
                :rules="[RuleRangeList(form.monitorRange.rangeList, index)]"
              >
                <el-row
                  v-if="form.monitorRange.sign === 1"
                  :span="24"
                  class="uk-margin-small"
                >
                  <el-col :lg="12" :xl="12" class="uk-flex uk-flex-nowrap">
                    <el-select
                      v-model="item.code"
                      class="select-standard-width"
                    >
                      <el-option value="temp" :label="$t('public.temp')"></el-option>
                      <el-option value="hum" :label="$t('public.hum')"></el-option>
                      <el-option value="gs_1" :label="$t('gasType.0x00')"></el-option>
                      <el-option value="gs_2" :label="$t('gasType.0x01')"></el-option>
                      <el-option value="gs_3" :label="$t('gasType.0x04')"></el-option>
                      <el-option value="gs_4" :label="$t('gasType.0x0A')"></el-option>
                      <el-option value="gs_5" :label="$t('gasType.0x32')"></el-option>
                    </el-select>
                    <el-select
                      v-model="item.type"
                      class="select-standard-width"
                    >
                      <el-option
                        :value="item.value"
                        :label="item.label"
                        :key="item.value"
                        v-for="item in compareOption"
                      ></el-option>
                    </el-select>
                  </el-col>

                  <el-col :lg="12" :xl="12" class="uk-flex uk-flex-nowrap">
                    <div class="pl-5  temp-range">
                      <!--区间-->
                      <template v-if="item.type === 0">
                        <el-input
                          v-model="item.min"
                          class="input"
                          style="width:40px"
                        ></el-input>
                        <span class="unit">{{ customUnit[item.code] }}</span>

                        <el-input
                          class="input"
                          v-model="item.max"
                          style="width:40px"
                        ></el-input>
                      </template>
                      <!--小于或小于等于-->
                      <template v-else-if="item.type === 2 || item.type === 4">
                        <el-input
                          v-model="item.min"
                          style="width:120px"
                          class="input"
                        ></el-input>
                      </template>
                      <!--大于或大于等于-->
                      <template v-else-if="item.type === 1 || item.type === 3">
                        <el-input
                          v-model="item.max"
                          style="width:120px"
                          class="input"
                        ></el-input>
                      </template>
                      <span class="unit">{{ customUnit[item.code] }}</span>
                    </div>

                    <div class="ml-5 uk-flex uk-flex-nowrap mt-5">
                      <i
                        class="el-icon-delete color-red mr-5 font-16 cursor-pointer"
                        @click="delRange(index)"
                      ></i>
                      <i
                        v-if="index === form.monitorRange.rangeList.length - 1"
                        class="el-icon-circle-plus font-16 cursor-pointer"
                        @click="addRange"
                      ></i>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <!-- 监测区间第二行-->
            </el-form-item>
            <el-form-item :label="$t('public.passing_rate')" class="pass-percent">
              <template v-for="(item, index) in form.proportionClxList">
                <el-row :key="index" class="uk-margin-small-bottom">
                  <el-col :lg="12" :xl="12">
                    <div class="uk-flex">
                      <el-select
                        v-model="item.type"
                        class="select-standard-width"
                      >
                        <el-option
                          :value="item.value"
                          :label="item.label"
                          v-for="item in compareOption.slice(1)"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                      <el-color-picker
                        v-model="item.color"
                        class="select-standard-width"
                      ></el-color-picker>
                    </div>
                  </el-col>

                  <el-col :lg="12" :xl="12" class="uk-flex uk-flex-nowrap">
                    <div class="uk-flex uk-flex-nowrap percent">
                      <span class="unit">{{ compareMap[item.type] }}</span>
                      <el-input
                        class="input"
                        style="width: 78px"
                        v-model="item.val"
                      ></el-input>
                      <span class="unit">%</span>
                    </div>
                    <div class="ml-5 uk-flex uk-flex-nowrap mt-5">
                      <i
                        class="el-icon-delete color-red font-16 cursor-pointer mr-5"
                        @click="delPropotion(index)"
                      ></i>
                      <i
                        v-if="index === form.proportionClxList.length - 1"
                        class="el-icon-circle-plus font-16 cursor-pointer"
                        @click="addPropotion"
                      ></i>
                    </div>
                  </el-col>
                </el-row>
              </template>
            </el-form-item>

            <el-form-item :label="$t('public.statistic_object')" class="uk-margin-small-top">
              <StatisticObject
                :tree-data="treeData"
                :checked="form.object"
                @onTreeConfirm="onTreeConfirm"
              ></StatisticObject>

              <!--默认区间对象-->
              <template v-if="form.monitorRange.sign === 0">
                <el-col
                  :span="24"
                  :key="index"
                  v-for="(range, index) in rangeList"
                >
                  <div class="uk-margin-small-top">
                    <div class="range-title lh-30">
                      {{ range.min }}{{ range.unit }} ~ {{ range.max
                      }}{{ range.unit }}
                    </div>
                    <StatisticObject
                      hide-button
                      :tree-data="treeData"
                      :checked="range.carrierIdList.join(',')"
                    ></StatisticObject>
                  </div>
                </el-col>
              </template>
            </el-form-item>
            <el-form-item class="uk-margin-small-top">
              <el-button
                type="primary"
                class="btn-w uk-margin-small-right"
                @click="onSave"
                >{{ $t('public.save') }}
              </el-button>

              <el-button type="primary" class="btn-w " @click="preview"
                >{{ $t('integration.preview') }}
              </el-button>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import StatisticObject from '@/pages/count/statistic/component/StatisticObject/StatisticObject.vue'
import { shareTree } from '@/api/modules/public'
import {
  getProportionDefault,
  getRangeDefault
} from '@/pages/count/statistic/config/default'
import { defaultUnit } from '@/utils/convert'
import {
  exportStatic,
  getRange,
  getStaticList,
  previewStatic,
  saveStatic
} from '@/api/modules/static'
import { RuleRangeList } from '@/pages/count/statistic/config/rules/condition'
import { RuleRequiredFunc } from '@/utils/rules'
import { getExportLanguage } from '@/lang'
import { shareUnit } from '../../../../api/modules/public'
import { getLanguage } from '@/lang';
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  created () {
    this.UnitMeasurementFn();
  },
  computed: {
    RuleRangeList () {
      return RuleRangeList
    },
    compareMap () {
      return {
        1: '≥',
        2: '≤',
        3: '>',
        4: '<'
      }
    }
  },
  components: {
    StatisticObject
  },
  data () {
    return {
      form: {
        id: null,
        name: '',
        startTime: new Date().getTime() - 3 * 24 * 60 * 60 * 1000,
        endTime: new Date().getTime(),
        monitorRange: {
          sign: 1,
          rangeList: [getRangeDefault()]
        },
        proportionClxList: [getProportionDefault()],
        object: ''
      },
      treeData: [],
      // 统计名称列表 保存不至于重复请求
      staticList: [],
      // 自定义区间列表
      rangeList: [],

      customUnit: [],

      compareOption: [
        {
          label: $t('text.Interval'),
          value: 0
        },
        {
          label: $t('public.greater_than_equal'),
          value: 1
        },
        {
          label: $t('public.less_than_equal'),
          value: 2
        },
        {
          label: $t('public.greater_than'),
          value: 3
        },
        {
          label: $t('public.less_than'),
          value: 4
        }
      ]
    }
  },

  methods: {
    RuleRequiredFunc,
    UnitMeasurementFn () {
      shareUnit().then(({ result }) => {
        let obj = {};
        result.forEach(item => {
          obj[item.code] = item.name;
        });
        this.customUnit = obj;
      })
    },
    formatTempValue(val) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'
      const result = TempUtils.convertToCelsius(numVal, this.tempUnit)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}`
    },
    getTree () {
      shareTree({
        isEdit: 0,
        carrier: true,
        all: true
      }).then(({ result }) => {
        this.treeData = (result && result.item) || []
      })
    },
    addRange () {
      this.form.monitorRange.rangeList.push(getRangeDefault())
    },
    addPropotion () {
      this.form.proportionClxList.push(getProportionDefault())
    },
    async delRange (index) {
      if (this.form.monitorRange.rangeList.length === 1) {
        return this.$message.warning(this.$t('public.keep_at_least_one_item'))
      }
      await this.$confirm(this.$t('public.confirm_delete_item'))
      this.form.monitorRange.rangeList.splice(index, 1)
    },
    async delPropotion (index) {
      if (this.form.proportionClxList.length === 1) {
        return this.$message.warning(this.$t('public.keep_at_least_one_item'))
      }
      await this.$confirm(this.$t('public.confirm_delete_item'))
      this.form.proportionClxList.splice(index, 1)
    },
    onTreeConfirm (carriers) {
      this.form.object = carriers.join(',')
      if (this.form.monitorRange.sign === 0 && this.form.object) {
        getRange(this.form.object).then(({ result }) => {
          this.rangeList = result
          this.form.monitorRange.rangeList = this.rangeList.map(item => ({
            type: 0,
            code: item.code,
            min: item.min,
            max: item.max
          }))
        })
      }
    },
    // 监测区间背选择
    onMonitorSelect (sign) {
      if (sign === 0 && this.form.object.split(',').length) {
        this.onTreeConfirm(this.form.object.split(','))
      }
    },
    async onSave () {
      await this.$refs.form.validate()
      if (!this.form.object) {
        return this.$message.warning(this.$t('public.select_at_least_one_asset'))
      }
      this.$emit('onSave', this.$emit('onSave', this.form))
      saveStatic(this.form).then(({ result, state }) => {
        if (state.code === 200) {
          this.form.id = result
          this.$message.success(this.$t('integration.saved_successfully'))
        }
      })
    },
    queryStaticList (queryString, cb) {
      if (this.staticList.length) {
        return cb(this.staticList)
      }
      getStaticList().then(({ result }) => {
        this.staticList = result.map(item => {
          item.value = item.name
          return item
        })
        cb(this.staticList)
      })
    },
    onStaticSelect (data) {
      data = { ...data }
      this.$refs.form.clearValidate()

      const monitorRange = JSON.parse(data.monitorRange)
      const proportionCondition = JSON.parse(data.proportionCondition)
      data.monitorRange = monitorRange
      data.proportionClxList = proportionCondition
      this.form = { ...data }
      this.form.object = data.statisticsObject
      if (this.form.monitorRange.sign === 0) {
        this.onTreeConfirm(this.form.object.split(','))
      }
    },
    async preview () {
      await this.$refs.form.validate()
      if (!this.form.object) {
        return this.$message.warning(this.$t('public.select_at_least_one_asset'))
      }
      this.$loading.show({
        lock: true,
        text: this.$t('text.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // el-input 会将数值绑定为字符串，后端解析空字符串会抛 NumberFormatException
      // 提交前将 min/max/val 转为数字，空值转 0
      const formData = JSON.parse(JSON.stringify(this.form))
      formData.monitorRange.rangeList.forEach(item => {
        item.min = item.min === '' ? 0 : Number(item.min)
        item.max = item.max === '' ? 0 : Number(item.max)
      })
      formData.proportionClxList.forEach(item => {
        item.val = item.val === '' ? 0 : Number(item.val)
      })

      previewStatic(formData)
        .then(({ result }) => {
          this.$emit('onPreview', result)
        })
        .finally(() => {
          this.$loading.hide()
        })
    },
    async exp () {
      await this.$refs.form.validate()
      await this.$confirm(this.$t('public.sure_want_to_export'))

      exportStatic({
        ...this.form,
        lang: getExportLanguage()
      }).then(({ result }) => {
        this.$store.state.downLoad.listids.push(result.recordId)
        this.$message.success(this.$t('public.Export_successful') + ', ' + this.$t('public.go_download_page_view'))
      })
    },
    onFormValidate (prop, boolean, message) {
      if (!boolean) {
        this.$message.warning(message)
      }
    }
  },
  mounted () {
    this.getTree()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}

.input-width {
  width: 140px !important;
}

.input {
  ::v-deep .el-input__inner {
    border-radius: 0 !important;
    border: none;
    text-align: center;
    padding: 0;
  }
}

.temp-range {
  border: #ccc solid 1px;
  padding-left: 0;
  height: 30px;
  border-right: none;
  display: inline-flex;
  flex-wrap: nowrap;

  .unit {
    display: inline-block;
    width: 40px;
    text-align: center;
    box-sizing: border-box;
    border-left: solid 1px #ccc;
    border-right: solid 1px #ccc;
    height: 100%;
  }
}

.range-title {
  text-align: center;
  border: #ccc solid 1px;
  border-bottom: none;
}

.select-standard-width {
  width: 96.5px;
}

.pass-percent {
  box-sizing: border-box;

  .percent {
    border: #ccc 1px solid;
    display: inline-flex;
  }

  ::v-deep .el-color-picker__trigger {
    width: 100%;
  }

  .input {
    border-right: solid 1px #ccc;
    border-left: solid 1px #ccc;
  }

  .unit {
    display: inline-block;
    width: 40px;
    text-align: center;
  }
}

::v-deep .el-form-item__error {
  margin-top: -13px;
}
</style>
